import { HomePage } from "../pages/StarterPage/index";
import LovableIframePage from "../pages/LovableIframePage";
import SigninLandingPage from "../pages/SigninLandingPage";
import NewLogin from "../pages/Authentication/NewLogin/NewLogin";
import ResetPassword from "../pages/Authentication/NewLogin/ResetPassword";
import VerifyEmail from "../pages/Authentication/VerifyEmail/VerifyEmail";
import EmailVerificationPending from "../pages/Authentication/EmailVerificationPending/EmailVerificationPending";
import TermsPage from "../pages/TermsPage";
import DeleteAccountPage from "../pages/DeleteAccountPage";
import PrivacyPolicyPage from "../pages/PrivacyPolicyPage";
import TermsAndConditionsPage from "../pages/TermsAndConditionsPage";
import AOPromotionRedirect from "../components/AOPromotionRedirect";
import {
  CircleJoinPage,
  AccountAccessPage,
  ActivityPage,
  NotesPage,
  HealthRecordPage,
  DownloadFamPage,
} from "../pages/DeepLinkPage";
import { WEB_LOGIN_PATH } from "./authPaths";

interface RouteProps {
  path: string;
  component: any;
  exact?: boolean;
}

const publicRoutes: Array<RouteProps> = [
  { path: "/", component: <LovableIframePage /> },
  { path: "/about", component: <LovableIframePage /> },
  { path: "/chat", component: <HomePage /> },
  { path: "/signin", component: <SigninLandingPage /> },
  { path: WEB_LOGIN_PATH, component: <NewLogin /> },
  { path: "/terms", component: <TermsPage /> },
  { path: "/privacy-policy", component: <PrivacyPolicyPage /> },
  { path: "/terms-and-conditions", component: <TermsAndConditionsPage /> },
  { path: "/delete-your-account", component: <DeleteAccountPage /> },
  { path: "/reset-password", component: <ResetPassword /> },
  { path: "/verify-email", component: <VerifyEmail /> },
  { path: "/verification-pending", component: <EmailVerificationPending /> },
  { path: "/ao", component: <AOPromotionRedirect /> },
  // Deep link landing pages
  { path: "/circle/join", component: <CircleJoinPage /> },
  { path: "/account/access", component: <AccountAccessPage /> },
  { path: "/activities/:activityId", component: <ActivityPage /> },
  { path: "/notes/:notesId", component: <NotesPage /> },
  { path: "/health-record/:careRecipientId", component: <HealthRecordPage /> },
  { path: "/s/download", component: <DownloadFamPage /> },
  // Staging deep link landing pages
  { path: "/staging/circle/join", component: <CircleJoinPage /> },
  { path: "/staging/account/access", component: <AccountAccessPage /> },
  { path: "/staging/activities/:activityId", component: <ActivityPage /> },
  { path: "/staging/notes/:notesId", component: <NotesPage /> },
  { path: "/staging/health-record/:careRecipientId", component: <HealthRecordPage /> },
  { path: "/staging/s/download", component: <DownloadFamPage /> },
];


export { publicRoutes };
